const MAX_EMERGENCY_NUMBER = 2;
const FILE_REGEX = new RegExp("(\\.gpx)$", "i");
const UNAUTHORIZED_REDIRECT_PATH = "/sign-in";
const ONE_GPX_COST = 2;

export { MAX_EMERGENCY_NUMBER, FILE_REGEX, UNAUTHORIZED_REDIRECT_PATH, ONE_GPX_COST };
